import { useEffect, useState } from 'react';

export type BenefitNotification = {
  detail: string;
};

const benefits: BenefitNotification[] = [
  { detail: 'Acceso inmediato al material digital' },
  { detail: '100 instalaciones para consultar desde tu celular' },
  { detail: '10 módulos organizados por temática' },
  { detail: 'Acceso de por vida incluido' }
];

export function usePurchaseNotifications() {
  const [notification, setNotification] = useState<BenefitNotification | null>(null);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    let currentIndex = 0;
    let hideTimeout: ReturnType<typeof setTimeout> | undefined;

    const showNotification = () => {
      setNotification(benefits[currentIndex]);
      setIsVisible(true);
      currentIndex = (currentIndex + 1) % benefits.length;

      if (hideTimeout) clearTimeout(hideTimeout);
      hideTimeout = setTimeout(() => setIsVisible(false), 3800);
    };

    const firstTimeout = setTimeout(showNotification, 8000);
    const interval = setInterval(showNotification, 22000);

    return () => {
      clearTimeout(firstTimeout);
      clearInterval(interval);
      if (hideTimeout) clearTimeout(hideTimeout);
    };
  }, []);

  return { notification, isVisible };
}
